import type React from 'react';

import {
    Button,
    Card,
    CardActions,
    CardBody,
    CardImage,
    CardImageLayout,
    Description,
    Heading,
    ProgressiveImage,
} from '@gitbook/spine-react';

import { createDocumentationURL } from '../../../utils';
import imageDark from '../assets/byo-integration-dark.raw.svg';
import imageLight from '../assets/byo-integration-light.raw.svg';

/**
 * CTA inviting users to build their own integration.
 */
export function BuildYourOwnIntegration(): React.ReactElement {
    return (
        <Card>
            <CardImageLayout>
                <CardImage>
                    <ProgressiveImage
                        src={{ light: imageLight, dark: imageDark }}
                        width={123}
                        height={102}
                    />
                </CardImage>
                <CardBody>
                    <Heading>Can't find the integration you need? Build your own!</Heading>
                    <Description>
                        Visit our developer documentation to learn more about our integrations
                        platform and start creating your own.
                    </Description>
                    <CardActions>
                        <Button
                            kind="secondary"
                            label="Learn how"
                            href={createDocumentationURL('/integrations', 'developer')}
                        />
                    </CardActions>
                </CardBody>
            </CardImageLayout>
        </Card>
    );
}
